

import React, { useEffect, useState } from "react";
import axios from "axios";
import FRONTEND_CONFIG from "./frontend_config";
import { useNavigate } from "react-router-dom";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";



export default function AdminDashboard() {
  const [username, setUsername] = useState("");
  const [activeTab, setActiveTab] = useState("manage-applicant");
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [paymentInputs, setPaymentInputs] = useState({});
  const [statusInputs, setStatusInputs] = useState({});
  const [dirtyRows, setDirtyRows] = useState(new Set());
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
  if (applicants.length > 0) {
    const pendingCount = applicants.filter(a => a.status === "Pending").length;
    const approvedCount = applicants.filter(a => a.status === "Approved").length;
    const rejectedCount = applicants.filter(a => a.status === "Rejected").length;

    setChartData([
      { name: "Pending", value: pendingCount },
      { name: "Approved", value: approvedCount },
      { name: "Rejected", value: rejectedCount },
    ]);
  }
}, [applicants]);


  
  const navigate = useNavigate(); 

const handleLogout = () => {
  localStorage.removeItem("username");
  localStorage.removeItem("userRole");
  navigate("/login"); // redirect to login page
};



const handleLogin = () => {

  navigate("/login"); // redirect to login page
};

// ==========================================
  // Common Pagination / Sorting / Search States
  // ==========================================
const itemsPerPage = 25;
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });


// ==========================================
  // Print username & Role
  // ==========================================
const loggedInUser = localStorage.getItem("username") || "Unknown";
  const loggedInRole = localStorage.getItem("userRole") || "Unknown";

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) setUsername(storedUsername);
  }, []);


    // =========================
  // Manage Applicants Section
  // =========================


  




// Users tab states
const [users, setUsers] = useState([]);
const [userSearchTerm, setUserSearchTerm] = useState("");
const [userCurrentPage, setUserCurrentPage] = useState(1);
const [userSortConfig, setUserSortConfig] = useState({ key: null, direction: "asc" });

// New User Modal
const [showUserModal, setShowUserModal] = useState(false);
const [newUserData, setNewUserData] = useState({ email: "", password: "", role: "" });
const [userMessage, setUserMessage] = useState("");




  // For Update Modal
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [currentApplicant, setCurrentApplicant] = useState(null);

  //add(24-10-2025)
 
  const toggleRowSelection = (appId) => {
  setSelectedRows(prev => {
    const updated = new Set(prev);
    if (updated.has(appId)) {
      updated.delete(appId);
    } else {
      updated.add(appId);
    }
    return updated;
  });
};

// State for selected rows
const [selectedRows, setSelectedRows] = useState(new Set());

// Delete selected applicants
const handleDeleteSelected = async () => {
  if (selectedRows.size === 0) return;

  if (!window.confirm(`Delete ${selectedRows.size} selected applicant(s)?`)) return;

  const failed = [];

  for (const applicationId of selectedRows) {
    try {
      await axios.delete(
        `${FRONTEND_CONFIG.API_URL}/api/applicant/delete/${applicationId}`
      );
    } catch (err) {
      console.error("Failed to delete:", applicationId, err);
      failed.push(applicationId);
    }
  }

  if (failed.length > 0) {
    alert(`Failed to delete: ${failed.join(", ")}`);
  } else {
    alert("Selected applicants deleted successfully!");
  }

  setSelectedRows(new Set());
  fetchApplicants(); // refresh table
};




//create  editable field
const EditableCell = ({ value, onSave, type = "text" }) => {
  const [editing, setEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);

  useEffect(() => setTempValue(value), [value]);

  const handleSave = async () => {
    if (tempValue !== value) {
      await onSave(tempValue);
    }
    setEditing(false);
  };

  return (
    <td
      className="border p-2 text-center cursor-pointer"
      onClick={() => setEditing(true)}
    >
      {editing ? (
        <input
          type={type}
          className="border rounded px-2 py-1 w-full text-center"
          value={tempValue}
          autoFocus
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={handleSave}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSave();
            if (e.key === "Escape") setEditing(false);
          }}
        />
      ) : (
        <span>{value}</span>
      )}
    </td>
  );
};

  
  

  useEffect(() => {
    if (activeTab === "manage-applicant") fetchApplicants();
  }, [activeTab]);

  const fetchApplicants = async () => {
  try {
    const res = await axios.get("http://localhost:5000/api/applicant/all");

    // ✅ FIX HERE
    const apps = res.data.applicants || [];

    const payments = {};
    const statuses = {};

    apps.forEach((a) => {
      payments[a.applicationId] = {
        cashPayment: a.cashPayment || "",
        bankPayment: a.bankPayment || "",
      };
      statuses[a.applicationId] = a.status || "Pending";
    });

    setApplicants(apps);
    setPaymentInputs(payments);
    setStatusInputs(statuses);
    setDirtyRows(new Set());
    setLoading(false);
  } catch (err) {
    console.error(err);
    setLoading(false);
  }
};


  // Handlers
  const handlePaymentChange = (id, field, value) => {
    setPaymentInputs((prev) => {
      const updated = { ...prev, [id]: { ...(prev[id] || {}), [field]: value } };
      markRowDirty(id);
      return updated;
    });
  };



  

  const handleStatusChange = (id, value) => {
    setStatusInputs((prev) => {
      const updated = { ...prev, [id]: value };
      markRowDirty(id);
      return updated;
    });
  };

  const markRowDirty = (id) => setDirtyRows((prev) => new Set(prev).add(id));
  const clearRowDirty = (id) =>
    setDirtyRows((prev) => {
      const updated = new Set(prev);
      updated.delete(id);
      return updated;
    });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const sortedApplicants = React.useMemo(() => {
    let sortableItems = [...applicants];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        let aValue = a[sortConfig.key] ?? "";
        let bValue = b[sortConfig.key] ?? "";

        if (["cashPayment", "bankPayment"].includes(sortConfig.key)) {
          aValue = Number(aValue) || 0;
          bValue = Number(bValue) || 0;
        } else {
          aValue = aValue.toString().toLowerCase();
          bValue = bValue.toString().toLowerCase();
        }

        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableItems;
  }, [applicants, sortConfig]);

  const filteredApplicants = sortedApplicants.filter((a) =>
    [a.studentName, a.email, a.applicationId, a.contactNo]
      .filter(Boolean)
      .some((field) => field.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredApplicants.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedApplicants = filteredApplicants.slice(startIndex, startIndex + itemsPerPage);




  const handleSave = async (app) => {
    const cash = Number(paymentInputs[app.applicationId]?.cashPayment || 0);
    const bank = Number(paymentInputs[app.applicationId]?.bankPayment || 0);
    const status = statusInputs[app.applicationId];

    try {
      await axios.put(`${FRONTEND_CONFIG.API_URL}/api/applicant/update/${app.applicationId}`, {
        cashPayment: cash,
        bankPayment: bank,
        status: status,
        updater: loggedInUser,
      });
      alert("Saved successfully!");
      clearRowDirty(app.applicationId);
      fetchApplicants();
    } catch (err) {
      console.error("Failed to save:", err);
      alert("Failed to save changes");
    }
  };



//helper for user
const fetchUsers = async () => {
  try {
    const res = await axios.get(`${FRONTEND_CONFIG.API_URL}/api/user/all`);

    // ✅ FIX HERE
    setUsers(res.data.users || []);

  } catch (err) {
    console.error(err);
    alert("Failed to fetch users");
  }
};


useEffect(() => {
  if (activeTab === "manage-user") {
    fetchUsers();
  }
}, [activeTab]);


const handleUserSort = (key) => {
  let direction = "asc";
  if (userSortConfig.key === key && userSortConfig.direction === "asc") direction = "desc";
  setUserSortConfig({ key, direction });
};

const sortedUsers = React.useMemo(() => {
  let sortable = [...users];
  if (userSortConfig.key) {
    sortable.sort((a, b) => {
      let aVal = a[userSortConfig.key] ?? "";
      let bVal = b[userSortConfig.key] ?? "";
      aVal = aVal.toString().toLowerCase();
      bVal = bVal.toString().toLowerCase();
      if (aVal < bVal) return userSortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return userSortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }
  return sortable;
}, [users, userSortConfig]);

const filteredUsers = sortedUsers.filter((u) =>
  [u._id, u.email, u.role].some((field) => field.toLowerCase().includes(userSearchTerm.toLowerCase()))
);

const totalUserPages = Math.ceil(filteredUsers.length / itemsPerPage);
const startUserIndex = (userCurrentPage - 1) * itemsPerPage;
const paginatedUsers = filteredUsers.slice(startUserIndex, startUserIndex + itemsPerPage);

// Modal handlers
const handleOpenUserModal = () => {
  setShowUserModal(true);
  setNewUserData({email: "", password: "", role: "" });
  setUserMessage("");
};
const handleCloseUserModal = () => setShowUserModal(false);
const handleNewUserChange = (e) => setNewUserData({ ...newUserData, [e.target.name]: e.target.value });

const handleCreateNewUser = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post(`${FRONTEND_CONFIG.API_URL}/api/user/register`, newUserData);
    setUserMessage(res.data.message || "User created successfully!");
    fetchUsers();
    setTimeout(() => setShowUserModal(false), 1500);
  } catch (err) {
    setUserMessage(err.response?.data?.error || "Failed to create user");
  }
};




const [updateUserModalOpen, setUpdateUserModalOpen] = useState(false);
const [currentUser, setCurrentUser] = useState({ username: "", role: "" });
const [updateMessage, setUpdateMessage] = useState("");
const openUpdateUserModal = (user) => {
  setCurrentUser({ username: user.email, role: user.role });
  setUpdateMessage("");
  setUpdateUserModalOpen(true);
};
const handleUpdateUserChange = (e) => {
  setCurrentUser({ ...currentUser, [e.target.name]: e.target.value });
};
const handleUpdateUser = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.put(`${FRONTEND_CONFIG.API_URL}/api/user/update/${currentUser.email}`, currentUser);
    setUpdateMessage(res.data.message || "User updated successfully");
    fetchUsers(); // refresh table
    setTimeout(() => setUpdateUserModalOpen(false), 1500);
  } catch (err) {
    setUpdateMessage(err.response?.data?.message || "Failed to update user");
  }
};







// Dashboard stats
const totalApplications = applicants.length;
const totalUsers = users.length;
const totalFees = applicants.reduce((sum, a) => {
  const cash = Number(a.cashPayment) || 0;
  const bank = Number(a.bankPayment) || 0;
  return sum + cash + bank;
}, 0);




// {updateUserModalOpen && (
//   <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
//     <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md relative animate-fadeIn">
//       <button onClick={() => setUpdateUserModalOpen(false)} className="absolute top-3 right-3 text-gray-500 hover:text-red-600">X</button>
//       <h2 className="text-2xl font-bold mb-6 text-center text-gray-700">Update User</h2>
//       {updateMessage && <p className="text-center text-blue-600 mb-4 font-medium">{updateMessage}</p>}
//       <form onSubmit={handleUpdateUser} className="space-y-5">
//         <div>
//           <label className="block mb-1 text-gray-600 font-medium">Username</label>
//           <input type="text" name="username" value={currentUser.username} disabled className="w-full p-2 border rounded-lg bg-gray-100" />
//         </div>
//         <div>
//           <label className="block mb-1 text-gray-600 font-medium">Role</label>
//           <select name="role" value={currentUser.role} onChange={handleUpdateUserChange} required className="w-full p-2 border rounded-lg">
//             <option value="">Select Role</option>
//             <option value="admin">Admin</option>
//             <option value="accountant">Accountant</option>
//             <option value="examiner">Examiner</option>
//           </select>
//         </div>
//         <button type="submit" className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-all font-semibold">Update User</button>
//       </form>
//     </div>
//   </div>
// )}

{updateUserModalOpen && currentUser && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl relative animate-fadeIn">
      <button 
        className="absolute top-3 right-3 text-gray-500 hover:text-red-600" 
        onClick={() => setUpdateUserModalOpen(false)}
      >X</button>

      <h2 className="text-xl font-bold mb-4 text-center text-gray-700">Update User</h2>
      {updateMessage && <p className="text-center text-blue-600 mb-4 font-medium">{updateMessage}</p>}

      <form
        onSubmit={handleUpdateUser}
        className="space-y-4"
      >
        <div>
          <label className="block mb-1 font-medium text-gray-600">Username</label>
          <input 
            type="text" 
            name="username" 
            value={currentUser.username} 
            disabled 
            className="w-full p-2 border rounded-lg bg-gray-100"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-600">Role</label>
          <select 
            name="role" 
            value={currentUser.role} 
            onChange={handleUpdateUserChange} 
            required
            className="w-full p-2 border rounded-lg"
          >
            <option value="">Select Role</option>
            <option value="admin">Admin</option>
            <option value="accountant">Accountant</option>
            <option value="examiner">Examiner</option>
          </select>
        </div>

        <div className="flex justify-end gap-3">
          <button 
            type="button" 
            className="px-4 py-2 bg-gray-300 rounded" 
            onClick={() => setUpdateUserModalOpen(false)}
          >
            Cancel
          </button>
          <button 
            type="submit"
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
)}





const pieData = [
  { name: "Applications", value: totalApplications },
  { name: "Users", value: totalUsers },
  { name: "Fees Collected", value: totalFees }
];

const COLORS = ["#7B3F00", "#FFA500", "#22C55E"]; // brown, orange, green


//add for update 
const InlineEditable = ({ value, onSave, type = "text", options }) => {
  const [editing, setEditing] = React.useState(false);
  const [tempValue, setTempValue] = React.useState(value);

  React.useEffect(() => setTempValue(value), [value]);

  const handleSave = async () => {
    if (tempValue !== value) await onSave(tempValue);
    setEditing(false);
  };

  if (type === "select") {
    return editing ? (
      <select
        value={tempValue}
        autoFocus
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={(e) => e.key === "Enter" && handleSave()}
        className="border rounded px-2 py-1 w-full text-center"
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
    ) : (
      <span className="cursor-pointer" onClick={() => setEditing(true)}>
        {value}
      </span>
    );
  }

  return editing ? (
    <input
      type={type}
      value={tempValue}
      autoFocus
      onChange={(e) => setTempValue(e.target.value)}
      onBlur={handleSave}
      onKeyDown={(e) => e.key === "Enter" && handleSave()}
      className="border rounded px-2 py-1 w-full text-center"
    />
  ) : (
    <span className="cursor-pointer" onClick={() => setEditing(true)}>
      {value}
    </span>
  );
};


  // Open Update Modal
  const openUpdateModal = async (applicationId) => {
    try {
      const res = await axios.get(`${FRONTEND_CONFIG.API_URL}/api/scholarships/application/${applicationId}`);
      setCurrentApplicant(res.data.application);
      setUpdateModalOpen(true);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch applicant details");
    }
  };

  const renderContent = () => {
    if (activeTab === "manage-applicant") {
      return (
        <div className="p-4 sm:p-6">
          <div className="flex justify-end mb-2 text-sm text-gray-600 space-x-4">
            <span>👤 USER-{loggedInUser}</span>
            <span>🛡️ ROLE-{loggedInRole}</span>
          </div>

          <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-center text-[#7B3F00]">
            Applications
          </h1>

          <div className="mb-4 flex justify-center space-x-2">
           <button
  onClick={() => navigate("/scholarship")} // call the function
  className="bg-[#7B3F00] text-white px-4 py-2 rounded hover:bg-green-600"
>
  New
</button>


            <input
              type="text"
              placeholder="Search by Name, Email, Application ID, or Phone..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="border px-3 py-2 rounded w-full sm:w-1/2 text-center"
            />
          </div>

          {loading ? (
            <p>Loading applicants...</p>
          ) : (
            <>
              <div className="overflow-x-auto">
                {/* Delete Selected Button */}
{selectedRows.size > 0 && (
  <div className="mb-2 flex justify-end">
    <button
      onClick={handleDeleteSelected}
      className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
    >
      Delete Selected ({selectedRows.size})
    </button>
  </div>
)}

<table className="w-full border-collapse border border-gray-300 text-sm sm:text-base">
  <thead className="bg-gray-100">
    <tr>
      {/* Checkbox Column for Select All */}
      <th className="border p-2 text-center">
        <input
          type="checkbox"
          checked={selectedRows.size === paginatedApplicants.length && paginatedApplicants.length > 0}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRows(new Set(paginatedApplicants.map(a => a.applicationId)));
            } else {
              setSelectedRows(new Set());
            }
          }}
        />
      </th>

      {["applicationId", "studentName", "email", "contactNo", "status"].map((col) => (
        <th
          key={col}
          className="border p-2 cursor-pointer select-none"
          onClick={() => handleSort(col)}
        >
          {col.charAt(0).toUpperCase() + col.slice(1)}
        </th>
      ))}
      <th className="border p-2">Cash</th>
      <th className="border p-2">Bank</th>
      <th className="border p-2">Total</th>
      {/* <th className="border p-2">Paid Date</th>
      <th className="border p-2">Approved By</th> */}
    </tr>
  </thead>

  <tbody>
    {paginatedApplicants.map((app) => {
      const cash = Number(paymentInputs[app.applicationId]?.cashPayment || 0);
      const bank = Number(paymentInputs[app.applicationId]?.bankPayment || 0);
      const total = cash + bank;
      const status = statusInputs[app.applicationId];

      // Auto-save function
      const handleAutoSave = async (appId, field, value) => {
  try {
    const payload = {
      cashPayment: Number(paymentInputs[appId]?.cashPayment || 0),
      bankPayment: Number(paymentInputs[appId]?.bankPayment || 0),
      status: statusInputs[appId],
    };

    // ✅ ADD THESE
    if (field === "studentName") payload.studentName = value;
    if (field === "email") payload.email = value;
    if (field === "contactNo") payload.contactNo = value;

    if (field === "status") payload.status = value;
    if (field === "cashPayment") payload.cashPayment = Number(value);
    if (field === "bankPayment") payload.bankPayment = Number(value);

    await axios.put(
      `${FRONTEND_CONFIG.API_URL}/api/applicant/update/${appId}`,
      {
        ...payload,
        lastUpdatedBy: loggedInUser,
      }
    );

    // ✅ Update local state so UI reflects change
    setApplicants(prev =>
      prev.map(a =>
        a.applicationId === appId ? { ...a, [field]: value } : a
      )
    );

  } catch (err) {
    console.error("Auto-save failed:", err);
  }
};


      // Toggle row selection
      const toggleRowSelection = (id) => {
        setSelectedRows(prev => {
          const newSet = new Set(prev);
          if (newSet.has(id)) newSet.delete(id);
          else newSet.add(id);
          return newSet;
        });
      };

      return (
        <tr key={app._id} className="hover:bg-gray-50">
          {/* Row selection checkbox */}
          <td className="border p-2 text-center">
            <input
              type="checkbox"
              checked={selectedRows.has(app.applicationId)}
              onChange={() => toggleRowSelection(app.applicationId)}
            />
          </td>

          <td className="border p-2 text-center">{app.applicationId}</td>

          {/* Editable text fields */}
         
            {/* Editable text fields */}
<input
  type="text"
  value={app.studentName || ""}
  className="w-full border rounded px-2 py-1"
  onChange={(e) => {
    const value = e.target.value;
    setApplicants(prev =>
      prev.map(a =>
        a.applicationId === app.applicationId
          ? { ...a, studentName: value }
          : a
      )
    );
  }}
  onBlur={(e) =>
    handleAutoSave(app.applicationId, "studentName", e.target.value)
  }
/>


          

          <td className="border p-2">
           <input
  type="text"
  value={app.email || ""}
  className="w-full border rounded px-2 py-1"
  onChange={(e) => {
    const value = e.target.value;
    setApplicants(prev =>
      prev.map(a =>
        a.applicationId === app.applicationId
          ? { ...a, email: value }
          : a
      )
    );
  }}
  onBlur={(e) =>
    handleAutoSave(app.applicationId, "email", e.target.value)
  }
/>

          </td>

          <input
  type="text"
  value={app.contactNo || ""}
  className="w-full border rounded px-2 py-1"
  onChange={(e) => {
    const value = e.target.value;
    setApplicants(prev =>
      prev.map(a =>
        a.applicationId === app.applicationId
          ? { ...a, contactNo: value }
          : a
      )
    );
  }}
  onBlur={(e) =>
    handleAutoSave(app.applicationId, "contactNo", e.target.value)
  }
/>


          {/* Status dropdown */}
          <td className="border p-2 text-center">
  <select
    value={status}
    onChange={(e) => {
      const newStatus = e.target.value;

      // ✅ update UI immediately
      setStatusInputs(prev => ({
        ...prev,
        [app.applicationId]: newStatus
      }));

      // ✅ auto-save to backend
      handleAutoSave(app.applicationId, "status", newStatus);
    }}
    className="border rounded px-2 py-1"
  >
    <option value="Pending">Pending</option>
    <option value="Approved">Approved</option>
    <option value="Rejected">Rejected</option>
  </select>
</td>


          {/* Cash input */}
          <td className="border p-2 text-center">
            <input
              type="number"
              className="border rounded px-2 py-1 w-24 text-center"
              value={cash}
              onChange={(e) => setPaymentInputs(prev => ({
                ...prev,
                [app.applicationId]: { ...prev[app.applicationId], cashPayment: e.target.value }
              }))}
              onBlur={(e) => handleAutoSave(app.applicationId, "cashPayment", e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
            />
          </td>

          {/* Bank input */}
          <td className="border p-2 text-center">
            <input
              type="number"
              className="border rounded px-2 py-1 w-24 text-center"
              value={bank}
              onChange={(e) => setPaymentInputs(prev => ({
                ...prev,
                [app.applicationId]: { ...prev[app.applicationId], bankPayment: e.target.value }
              }))}
              onBlur={(e) => handleAutoSave(app.applicationId, "bankPayment", e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
            />
          </td>

          {/* Total */}
          <td className="border p-2 text-center font-medium">₹{total.toFixed(2)}</td>

          <td className="border p-2 text-center">
            {app.paymentReceivedOn ? new Date(app.paymentReceivedOn).toLocaleDateString() : "-"}
          </td>
          <td className="border p-2 text-center">{app.paymentApprovedBy || "-"}</td>
        </tr>
      );
    })}
  </tbody>
</table>

              </div>

              <div className="mt-4 flex justify-center gap-2 flex-wrap">
                <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p-1)} className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50">Prev</button>
                {[...Array(totalPages)].map((_, i) => (
                  <button key={i} onClick={() => setCurrentPage(i+1)} className={`px-3 py-1 rounded ${currentPage===i+1?"bg-blue-500 text-white":"bg-gray-200"}`}>{i+1}</button>
                ))}
                <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p+1)} className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50">Next</button>
              </div>
            </>
          )}

          {/* Update Modal */}
          {updateModalOpen && currentApplicant && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white w-full max-w-3xl p-6 rounded shadow-lg overflow-y-auto max-h-[90vh]">
                <h2 className="text-xl font-bold mb-4">Update Applicant - {currentApplicant.studentName}</h2>

                <div className="grid grid-cols-2 gap-4">
                  {Object.keys(currentApplicant).map((key) => {
                    if (typeof currentApplicant[key] === "object" || key === "_id") return null;
                    return (
                      <div key={key}>
                        <label className="block font-medium">{key}</label>
                        <input
                          className="border rounded px-2 py-1 w-full"
                          value={currentApplicant[key] || ""}
                          onChange={(e) => setCurrentApplicant({ ...currentApplicant, [key]: e.target.value })}
                        />
                      </div>
                    );
                  })}
                </div>

                <div className="mt-6 flex justify-end gap-3">
                  <button
                    className="px-4 py-2 bg-gray-300 rounded"
                    onClick={() => setUpdateModalOpen(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="px-4 py-2 bg-green-500 text-white rounded"
                    onClick={async () => {
                      try {
                       await axios.put(
  `${FRONTEND_CONFIG.API_URL}/api/applicant/update/${currentApplicant.applicationId}`,
  {
    ...currentApplicant,
    lastUpdatedBy: loggedInUser,
  }
);

                        alert("Applicant updated successfully!");
                        setUpdateModalOpen(false);
                        fetchApplicants();
                      } catch (err) {
                        console.error(err);
                        alert("Failed to update applicant");
                      }
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

  if (activeTab === "manage-user") {
  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-center text-[#7B3F00]"> User</h1>

      <div className="mb-4 flex justify-center space-x-2">
        <button
          onClick={handleOpenUserModal}
          className="bg-[#7B3F00] text-white px-4 py-2 rounded hover:bg-green-600"
        >
          New
        </button>
        <input
          type="text"
          placeholder="Search by ID, Name, Role..."
          value={userSearchTerm}
          onChange={(e) => { setUserSearchTerm(e.target.value); setUserCurrentPage(1); }}
          className="border px-3 py-2 rounded w-full sm:w-1/2 text-center"
        />
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-sm sm:text-base">
          <thead className="bg-gray-100">
            <tr>
              {["_id", "email", "role"].map((col) => (
                <th key={col} className="border p-2 cursor-pointer" onClick={() => handleUserSort(col)}>
                  {col.charAt(0).toUpperCase() + col.slice(1)}
                </th>
              ))}
              <th className="border p-2">Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedUsers.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center p-4">No records found</td>
              </tr>
            ) : (
              paginatedUsers.map((u) => (
                <tr key={u._id} className="hover:bg-gray-50">
                  <td className="border p-2 text-center">{u._id}</td>
                  <td className="border p-2 text-center">{u.email}</td>
                  <td className="border p-2 text-center">{u.role}</td>
                  <td className="border p-2 text-center space-x-1">
                    <button
                      className="px-2 py-1 bg-blue-500 text-white rounded text-xs"
                      onClick={() => alert(JSON.stringify(u, null, 2))}
                    >
                      View
                    </button>
                    <button
  className="px-2 py-1 bg-green-500 text-white rounded text-xs"
  onClick={() => openUpdateUserModal(u)}
>
  Update
</button>

                    <button
  className="px-2 py-1 bg-red-500 text-white rounded text-xs"
  onClick={async () => {
    if (window.confirm("Are you sure to delete this user?")) {
      await axios.delete(`${FRONTEND_CONFIG.API_URL}/api/user/delete/${u.username}`);
      fetchUsers();
    }
  }}
>
  Delete
</button>


                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex justify-center gap-2 flex-wrap">
        <button disabled={userCurrentPage === 1} onClick={() => setUserCurrentPage(p => p-1)} className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50">Prev</button>
        {[...Array(totalUserPages)].map((_, i) => (
          <button key={i} onClick={() => setUserCurrentPage(i+1)} className={`px-3 py-1 rounded ${userCurrentPage===i+1?"bg-blue-500 text-white":"bg-gray-200"}`}>{i+1}</button>
        ))}
        <button disabled={userCurrentPage === totalUserPages} onClick={() => setUserCurrentPage(p => p+1)} className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50">Next</button>
      </div>

      {/* --- New User Modal --- */}
      {showUserModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md relative animate-fadeIn">
            <button onClick={handleCloseUserModal} className="absolute top-3 right-3 text-gray-500 hover:text-red-600">X</button>
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-700">Create New User</h2>
            {userMessage && <p className="text-center text-blue-600 mb-4 font-medium">{userMessage}</p>}
            <form onSubmit={handleCreateNewUser} className="space-y-5">
              <div>
                <label className="block mb-1 text-gray-600 font-medium">Username</label>
                <input type="text" name="username" value={newUserData.username} onChange={handleNewUserChange} required className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block mb-1 text-gray-600 font-medium">Password</label>
                <input type="password" name="password" value={newUserData.password} onChange={handleNewUserChange} required className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block mb-1 text-gray-600 font-medium">Role</label>
                <select name="role" value={newUserData.role} onChange={handleNewUserChange} required className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
                  <option value="">Select Role</option>
                  <option value="admin">Admin</option>
                  <option value="accountant">Accountant</option>
                  <option value="examiner">Examiner</option>
                </select>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-all font-semibold">Register User</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}









    if (activeTab === "manage-exam") return <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
  <div className="bg-white p-4 rounded shadow text-center">
    <h2 className="text-gray-500 font-medium">Total Applications</h2>
    <p className="text-2xl font-bold text-[#7B3F00]">{totalApplications}</p>
  </div>

  <div className="bg-white p-4 rounded shadow text-center">
    <h2 className="text-gray-500 font-medium">Total Users</h2>
    <p className="text-2xl font-bold text-[#7B3F00]">{totalUsers}</p>
  </div>

  <div className="bg-white p-4 rounded shadow text-center">
    <h2 className="text-gray-500 font-medium">Total Fees Collected</h2>
    <p className="text-2xl font-bold text-[#7B3F00]">₹{totalFees.toFixed(2)}</p>
  </div>


  <div className="w-full flex flex-col md:flex-row gap-6 mt-6">
  {/* Pie Chart 1: Dashboard Overview */}
  <div className="flex-1 h-72 bg-white rounded shadow p-4">
    <h2 className="text-lg font-bold text-gray-700 mb-4 text-center">
      Dashboard Overview
    </h2>
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={pieData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#8884d8"
          label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value) =>
            typeof value === "number" ? value.toLocaleString() : value
          }
        />
        <Legend verticalAlign="bottom" height={36} />
      </PieChart>
    </ResponsiveContainer>
  </div>

  {/* Pie Chart 2: Applicant Status Distribution */}
  <div className="flex-1 h-72 bg-white rounded shadow p-4">
    <h2 className="text-lg font-bold text-gray-700 mb-4 text-center">
      Applicant Status Distribution
    </h2>
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={80}
          label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
        >
          {chartData.map((entry, index) => {
            const COLORS = ["#FFBB28", "#00C49F", "#FF4444"];
            return (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            );
          })}
        </Pie>
        <Tooltip />
        <Legend verticalAlign="bottom" height={36} />
      </PieChart>
    </ResponsiveContainer>
  </div>
</div>



<div className="chart-section" style={{ width: "100%", height: 300, marginTop: "2rem" }}>
  <h3 style={{ textAlign: "center", marginBottom: "1rem" }}>Applicant Status Distribution</h3>
  <ResponsiveContainer>
    <PieChart>
      <Pie
        data={chartData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={100}
        label
      >
        {chartData.map((entry, index) => {
          const COLORS = ["#FFBB28", "#00C49F", "#FF4444"];
          return <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />;
        })}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  </ResponsiveContainer>
</div>


</div>





  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <header className="bg-[#7B3F00] text-white flex items-center justify-between px-8 py-4 shadow-md">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-white text-[#7B3F00] font-bold text-xl rounded flex items-center justify-center">School logo</div>
          <h1 className="text-2xl font-semibold">School name</h1>
        </div>
        <div className="text-sm">
          Welcome, <span className="font-bold text-yellow-300">{username || "Admin"}</span>
        </div>
         <button
      onClick={handleLogout}
      className="bg-red-500 px-3 py-1 rounded hover:bg-red-600 transition text-white font-medium"
    >
      Logout
    </button>


    
      </header>

      <nav className="bg-[#8B4513] text-white flex justify-center gap-10 py-3 shadow-md">
        <button onClick={() => setActiveTab("manage-applicant")} className={`transition ${activeTab==="manage-applicant"?"text-yellow-300 font-semibold":"hover:text-yellow-200"}`}> Applications</button>
        <button onClick={() => setActiveTab("manage-user")} className={`transition ${activeTab==="manage-user"?"text-yellow-300 font-semibold":"hover:text-yellow-200"}`}>User</button>
        <button onClick={() => setActiveTab("manage-exam")} className={`transition ${activeTab==="manage-exam"?"text-yellow-300 font-semibold":"hover:text-yellow-200"}`}>Dashboard</button>
      </nav>

      <main className="flex-1 mt-4">{renderContent()}</main>
    </div>
  );
}
